import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const FormattedNumber = ({
  number,
  isCost,
}: {
  number: number | string;
  isCost?: boolean;
}) => {
  const theme = useTheme();
  const colors = theme.palette;
  const [integerPart, decimalPart] = number.toString().split('.');

  return (
    <Stack direction="row" alignItems="baseline" sx={{ color: colors?.kpiTile?.text?.value }}>
      <Typography variant="widgetValueNew">{`${isCost ? '$ ' : ''}${integerPart}`}</Typography>
      {decimalPart && (
        <Typography
          variant={'widgetValueNew'}
          m={0}
          sx={{ color: colors?.kpiTile?.text?.value }}
        >{`.${decimalPart}`}</Typography>
      )}
    </Stack>
  );
};

export default FormattedNumber;
